import { CustomBottomBar, CustomPageTitle, MinimalStepper } from '@components';
import { Button, Container, Typography } from '@design-system';
import React from 'react';
import { FaGraduationCap } from 'react-icons/fa';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormation } from '@contexts/FormationContext/FormationContext';

export const FormationTalkResultsPage: React.FC = () => {
    const { categoryId, formationId } = useParams();
    const navigate = useNavigate();
    const { score, questionsAnswers } = useFormation();

    const totalQuestions = questionsAnswers.length;
    const percentage = totalQuestions > 0 ? Math.round(((score || 0) / totalQuestions) * 100) : 0;

    return (
        <Container className="formation-talk-results-page" height="fill">
            <CustomPageTitle>
                <Typography intrinsic="h3" iconColor="blue" icon={<FaGraduationCap />} iconFilled iconSize={20}>
                    Résultats du quiz
                </Typography>
            </CustomPageTitle>

            <MinimalStepper
                steps={[
                    { label: 'Les instructions', status: 'completed' },
                    { label: 'Le quizz', status: 'completed' },
                    { label: 'Emargement', status: 'pending' }
                ]}
            />

            <Container className="results-content" center column>
                <Typography intrinsic="h2" defaultSpacing>
                    Félicitations !
                </Typography>

                <Typography intrinsic="h3" defaultSpacing>
                    Vous avez obtenu {score} bonnes réponses sur {totalQuestions}
                </Typography>

                <Typography intrinsic="h4" color="green" defaultSpacing>
                    Score : {percentage}%
                </Typography>

                {percentage >= 80 ? (
                    <Typography intrinsic="p" color="green" defaultSpacing>
                        Excellent ! Vous pouvez maintenant passer à l'émargement.
                    </Typography>
                ) : (
                    <Typography intrinsic="p" color="red" defaultSpacing>
                        Vous devez obtenir au moins 80% pour valider cette formation.
                    </Typography>
                )}
            </Container>

            <CustomBottomBar>
                <Button
                    color="marine"
                    size="fullwidth"
                    icon={<MdKeyboardArrowRight />}
                    iconPosition="forced-right"
                    iconColor="white"
                    iconSize={30}
                    disabled={percentage < 80}
                    onClick={() => {
                        navigate(`/sante-securite/formations/list/${categoryId}/emargement/${formationId}`);
                    }}
                >
                    <Typography intrinsic="p">Continuer vers l'émargement</Typography>
                </Button>
            </CustomBottomBar>
        </Container>
    );
};
